import xhr from 'xhr';

export default async function getUser(data) {
  const res2 = await xhr(`/students?filters[id][$eq]=${data.id_est}&populate=user&populate=identity_type`);
  return res2.data.data;
}
